import StudentList from '../components/StudentList';

export default function StudentListPage() {
  return <StudentList />;
}